import type { MaterialSymbol } from "material-symbols";
import { SymbolIcon } from "widgets";

import { STRAND_TYPE } from "../../settings/strands.ts";

export const StrandDisplay = ({ strand }: { strand: string | null }) => {
  if (strand == null) {
    return null;
  }

  let color = "var(--text-default)";
  let icon: MaterialSymbol = "question_mark";

  switch (strand) {
    case STRAND_TYPE.PLUS:
      color = "var(--pale-teal-main)";
      icon = "add";
      break;
    case STRAND_TYPE.MINUS:
      color = "var(--lipstick-main)";
      icon = "remove";
      break;
  }

  return <SymbolIcon icon={icon} style={{ color }} />;
};
